import { useQuery } from "@tanstack/react-query";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { getTaskIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useTaskQuery = (taskId: number | null) => {
	return useQuery({
		queryKey: TaskKeys.detail(taskId),
		queryFn: processResponseQuery(() => getTaskIdV2(taskId!), {
			nullOn404: true,
		}),
		enabled: taskId !== null,
	});
};
